<div class="container">
    <div class="row">
        <div class="col-xs-12">
            <form novalidate>
                <div class="form-group">
                    <label class="pr-3">
                        Delete
                    </label>
                    <div class="radio d-inline">
                        <input type="radio"
                            name="deleteDocument"
                            id="deleteLatest"
                            [value]="true"
                            [(ngModel)]="deleteLatestVersion">
                        <label for="deleteLatest">
                           Only latest version
                        </label>
                    </div>
                    <div class="radio d-inline">
                        <input type="radio"
                            name="deleteDocument"
                            id="deleteAll"
                            [value]="false"
                            [(ngModel)]="deleteLatestVersion">
                        <label for="deleteAll">
                            All versions
                        </label>
                    </div>
                </div>

                <div class="col-xs-12 text-right">
                    <div class="clearfix">
                        <button type="button" class="btn btn-danger mr-2" (click)="cancel()" [disabled]="savingFlag">
                            <span>Cancel</span>
                        </button>
                        <button type="submit" class="btn btn-success" (click)="delete()" [disabled]="savingFlag">
                            <span *ngIf="!savingFlag">Delete</span>
                            <span *ngIf="savingFlag">Deleting..</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
